import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewSaveIcon: ComponentWithAs<'svg', IIconProps> = (props: any) => (
  <Icon
    data-testid="new-saved-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.764 2.27053C8.93752 1.96806 7.06248 1.96806 5.23602 2.27053C4.8923 2.32746 4.61931 2.58832 4.55079 2.92434C3.92739 5.9816 3.89337 9.12758 4.45053 12.1973L4.56572 12.832L7.15104 10.4058C7.62679 9.95932 8.37321 9.95932 8.84896 10.4058L11.4343 12.832L11.5495 12.1973C12.1066 9.12758 12.0726 5.9816 11.4492 2.92434C11.3807 2.58832 11.1077 2.32746 10.764 2.27053ZM5.06134 1.24122C7.00344 0.919593 8.99656 0.919593 10.9387 1.24122C11.7129 1.36944 12.3296 1.95655 12.4849 2.71825C13.1346 5.90418 13.17 9.18257 12.5894 12.3815L12.4334 13.241C12.3025 13.9624 11.4121 14.2508 10.8742 13.746L8.12128 11.1624C8.05332 11.0987 7.94668 11.0987 7.87872 11.1624L5.12576 13.746C4.58785 14.2508 3.69753 13.9624 3.5666 13.241L3.41059 12.3815C2.82999 9.18257 2.86543 5.90418 3.51507 2.71825C3.67039 1.95655 4.28711 1.36944 5.06134 1.24122Z"
      fill="currentColor"
    />
  </Icon>
);
